import React from 'react';
import { shortName } from '../../../../utils/strings';
import { imageLoadError } from '../../../../utils';
import { InnerContent, CardTitle, TwoColWrap, NoDataMessage, TeamLogoSmall } from '../styles';
import styled from 'styled-components';

const statusColor = status => {
    const s = (status || '').toLowerCase();
    if (s.includes('out')) return '#f87171';
    if (s.includes('doubt')) return '#fb923c';
    if (s.includes('question')) return '#fbbf24';
    if (s.includes('probable')) return '#4ade80';
    return '#94a3b8';
};

const InjuryList = ({ game }) => {
    const away = game?.awayTeam || {};
    const home = game?.homeTeam || {};
    const awayInjuries = away.injuries || [];
    const homeInjuries = home.injuries || [];

    if (!awayInjuries.length && !homeInjuries.length) {
        return (
            <InnerContent fluid>
                <NoDataMessage>
                    <i className="fas fa-file-medical" style={{ fontSize: '1.4rem', marginBottom: 8, display: 'block' }} />
                    <p style={{ margin: 0, fontSize: '0.85rem' }}>No injuries reported for this game.</p>
                </NoDataMessage>
            </InnerContent>
        );
    }

    const renderTeam = (team, injuries) => (
        <div>
            <CardTitle>
                {team.logoUrl && <TeamLogoSmall src={team.logoUrl} alt="" onError={imageLoadError} />}
                {shortName(team)}
            </CardTitle>
            {injuries.length === 0 ? (
                <NoInj>No injuries listed.</NoInj>
            ) : (
                <InjList>
                    {injuries.map((inj, i) => (
                        <InjItem key={i}>
                            <PlayerName>
                                {inj.player || inj.name || 'Unknown'}
                                {inj.position ? <Pos>({inj.position})</Pos> : null}
                            </PlayerName>
                            <Meta>
                                <Status style={{ color: statusColor(inj.status) }}>{inj.status || 'Unknown'}</Status>
                                {inj.date && <DateText>{inj.date}</DateText>}
                            </Meta>
                            {inj.desc && <Desc>{inj.desc}</Desc>}
                            {inj.value?.value !== undefined && (
                                <Desc>{inj.value.label}: {inj.value.value.toFixed(1)}</Desc>
                            )}
                        </InjItem>
                    ))}
                </InjList>
            )}
        </div>
    );

    return (
        <InnerContent fluid>
            <TwoColWrap>
                <div>{renderTeam(away, awayInjuries)}</div>
                <div>{renderTeam(home, homeInjuries)}</div>
            </TwoColWrap>
        </InnerContent>
    );
};

const InjList = styled.ul`list-style:none; margin:0; padding:0.3rem 0.4rem; border:1px solid rgba(255,255,255,0.08); background:rgba(255,255,255,0.03); border-radius:10px;`;
const InjItem = styled.li`padding:7px 8px; border-radius:6px; background:rgba(255,255,255,0.03); border:1px solid rgba(255,255,255,0.07); margin-bottom:4px; &:last-child{margin-bottom:0;}`;
const PlayerName = styled.div`font-size:0.76rem; font-weight:700; color:#e2e8f0;`;
const Pos = styled.span`font-size:0.68rem; color:#94a3b8; font-weight:500; margin-left:4px;`;
const Meta = styled.div`display:flex; align-items:center; gap:6px; margin-top:2px;`;
const Status = styled.span`font-size:0.68rem; font-weight:800; text-transform:uppercase; letter-spacing:0.03em;`;
const DateText = styled.span`font-size:0.66rem; color:#94a3b8;`;
const Desc = styled.div`font-size:0.7rem; color:#94a3b8; margin-top:2px; line-height:1.35;`;
const NoInj = styled.p`font-size:0.8rem; color:#94a3b8; padding:0.5rem 1rem; margin:0;`;

export default InjuryList;
